//Alert Keys

export const ERROR_KEY = "error";
export const WARNING_KEY = "warning";
export const SUCCESS_KEY = "success";
export const INFO_KEY = "info";

//-----

//Type Keys

export const NUMBER_KEY = "number";
export const BOOLEAN_KEY = "boolean";
export const OBJECT_KEY = "object";
export const STRING_KEY = "string";

//-----

//Currency Types - "$", "€", or "£"

export const AUD_KEY = "$";
export const EUR_KEY = "€";
export const GPB_KEY = "£";

//-----
